import { create } from "zustand";
import { persist } from "zustand/middleware";
import { set as _set } from "lodash-es";
import { TiLocale, DeployArea } from "../types";
import { getDeployArea, getDeployEnvArea } from "../utils";
const envArea = getDeployEnvArea();
const initialState = {
  locale: getDeployArea() === DeployArea.CN ? TiLocale.ZH_CN : TiLocale.EN_US,
  loginInfo: null
};
const useTiMaxStore = create(
  persist(
    (set) => ({
      ...initialState,
      setLocale: (locale) => {
        set({ locale });
      },
      setLoginInfo: (loginInfo) => {
        set({ loginInfo });
      },
      resetLoginInfo: () => {
        set({ loginInfo: initialState.loginInfo });
      },
      setUserInfo: (userInfo) => {
        set((s) => {
          _set(s, ["loginInfo", "userInfo"], userInfo);
          return { ...s };
        });
      },
      setMenu: (menu) => {
        set((s) => {
          _set(s, ["loginInfo", "menu"], menu);
          return { ...s };
        });
      }
    }),
    {
      name: `ti-max-store@${process.env.APP_NAME}@${envArea}`
    }
  )
);
var useTiMaxStore_default = useTiMaxStore;
export {
  useTiMaxStore_default as default
};
